import Button from 'components/ui/Button';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FC } from 'react';
import { InterfaceLanguage } from 'types/enums';
import SelectItem from '../SelectItem/Index';
import styles from './index.module.scss';
interface Props {
  onClose: () => void;
}

const DropdownPlatform: FC<Props> = ({ onClose }) => {
  const t = useTranslations();
  return (
    <div className={styles.overlay}>
      <div className={styles.overlayHeader}>
        <p className={styles.title}>{t('interface_language')}</p>
        <Button
          className={styles.crossButton}
          altStyleType={['icon', 'invertSvg']}
          onClick={onClose}>
          <Image src='/icons/cross.svg' alt='cross' width={16} height={16} />
        </Button>
      </div>
      {Object.values(InterfaceLanguage).map((lang, index) => (
        <div onClick={onClose} key={index + 1}>
          <SelectItem language={lang} />
        </div>
      ))}
    </div>
  );
};

export default DropdownPlatform;
